/*eslint-disable*/
import api from './../'

class MapConversationApi {
    static show(location) {
        return api.axios.get('/mapConversations/' + location)
            .then(response => response.data.mapConversation);
    }
}

export default MapConversationApi;